module.exports = __webpack_public_path__ + "img/3-3.a529c3c8.svg";